import { useQuery } from "react-query";
import { ScheduleAPI } from "api/schedule";
import { SCHEDULE } from "helpers/constants";

export default function useSchedule(ringId) {
  return useQuery([SCHEDULE, ringId], () => ScheduleAPI.getSchedule(ringId), {
    enabled: !!ringId,
  });
}
